import { GET_GROUPS, GET_GROUPS_SUCCESS, API_ERROR } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  groups: undefined,
}

const GroupsList = (state = initialState, action) => {
  switch (action.type) {
    case GET_GROUPS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_GROUPS_SUCCESS:
      state = {
        ...state,
        groups: action.payload.groups,
        loading: false,
        done: true,
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default GroupsList
